// src/components/DashboardLayout.js
import React from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

const DashboardLayout = ({ children, userId, businessId }) => {
    return (
        <div className="flex max-h-screen bg-gray-100">
            <div className="hidden sm:block">
                <Sidebar userId={userId} businessId={businessId} />
            </div>
            <div className="flex-1 flex flex-col">
                <Topbar userId={userId} />
                <main className="flex-1 p-6 md:p-8 overflow-y-auto">
                    {children} {/* This is where the actual dashboard content will be rendered */}
                </main>
            </div>
        </div>
    );
};

export default DashboardLayout;